import { render, staticRenderFns } from "./trendyol-commission-list.vue?vue&type=template&id=57369233"
import script from "./trendyol-commission-list.ts?vue&type=script&lang=js&external"
export * from "./trendyol-commission-list.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports